import Vue from "vue";
import Router from "vue-router";
import Top from "@/Pages/Index";
import Map from "@/Pages/Map/index";
// import Module from "@/Pages/Modules/Index";
Vue.use(Router);

const rootPath = "/";
export default new Router({
  mode: "history",
  routes: [
    {
      path: rootPath,
      name: "home",
      component: Top
      // beforeEnter: (to, from, next)=>{
      //   // console.log('top')
      //   next();
      // }
    },
    {
      path: "/map",
      name: "map",
      component: Map
      // beforeEnter: (to, from, next)=>{
      //   // console.log('top')
      //   next();
      // }
    }
    // {
    //   path: rootPath + "modules/:id",
    //   component: Module,
    //   name: "module"
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js